import { focusHaloFlush, HapticSurface, panelMotion, press } from "@pax/ui";
import { Link } from "@tanstack/react-router";
import { Plus, Search } from "lucide-react";

/**
 * The only two things on the front of the store that are not a scenario.
 *
 * They are peers — opposite ends of the same line, same size, same weight,
 * neither of them labelled — because neither is the thing the page is for.
 * The page is for the photograph behind them.
 *
 * No backdrop blur: over the photograph it makes the GPU redraw all of it on
 * every frame the screen changes width.
 */
const way = `relative flex size-9 items-center justify-center rounded-full bg-white/15 text-white ring-1 ring-white/25 hover:bg-white/25 ${panelMotion} ${press} ${focusHaloFlush}`;

/**
 * Searching is a way to somewhere else rather than somewhere to type, so it
 * is drawn as a link. A field would promise the answer arrives where you are
 * standing, and here it does not — it arrives on the search wall, which is a
 * screen of its own.
 *
 * Reached from the ways the wall is a peer of the store and arrives like one.
 * Reached from here it is not: you are opening it out of the page you are
 * standing on, so it deals a card the way opening a scenario does.
 */
export function SearchWay() {
  return (
    <Link
      to="/search"
      viewTransition={{ types: ["forward"] }}
      aria-label="Search scenarios"
      className={way}
    >
      <Search className="size-4" strokeWidth={1.75} />
      <HapticSurface />
    </Link>
  );
}

/**
 * Writing a scenario is a screen of its own, and where the way into it lives
 * is the only part of it the store decides.
 */
export function CreateWay({ onPress }: { onPress: () => void }) {
  return (
    <button type="button" onClick={onPress} aria-label="Write a scenario" className={way}>
      <Plus className="size-4.5" strokeWidth={1.75} />
      <HapticSurface />
    </button>
  );
}
